module.exports = `${require.publicPath}.gitkeep.d41d8cd9.`;